export default __webpack_public_path__ + "static/media/value-plus-inactive.c896d607.svg";